module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_left_bundled-bbbe8e60cc3d2d10f1d3af1b312ac96b.png";